import * as React from 'react';
import { NineSlice } from '../../components/NineSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { MultilineLabel } from '../../components/UI/MultilineLabel';
import { JButton } from '../../components/UI/JButton';
import { Settings } from '../Settings/Settings';
import { setSetting } from '../../slices/settingsSlice';
import { mute } from '../../util/MusicPlayer';
import { Portrait } from './Portrait';
import { CDNImage } from '../../components/Elements/Image';
import TopMenuBG from '../../assets/UIResource/TopMenu/backdrop.png';
import { switchState } from '../../slices/stateSlice';
import { SiteState } from '../../enums';
import { logOff, toServer } from '../../util/ServerSocket';
import { hideCodex, showCodex } from '../../slices/panelSlice';
import { Codex } from './Codex';
import { Ping } from './Ping';
import { Vip } from './Vip';
import { isMobileGameDevice } from '../../hooks/useMobileGameViewport';
import { ShinobiSpeaker } from '../../components/ShinobiSpeaker';
import { UserCenter } from '../Landing/UserCenter';
import { getUserCenterToken } from '../../util/userCenterSession';
import topupIcon from '../../assets/game-topup-icon.png';

export const TopMenu: React.FC<{}> = ({}) => {
  const dispatch = useAppDispatch();
  const [mobile]=React.useState(isMobileGameDevice);

  const stones = useAppSelector((state) => state.currency.stones);
  const settingsFirstSet = useAppSelector((state) => state.settings.firstSet);
  const isMuted = useAppSelector((state) => state.settings.mute);
  const currency = useAppSelector((state) => state.character.currency);
  const serverId = useAppSelector((state) => state.account.serverId);
  const serverVersion = useAppSelector((state) => state.account.version);
  const isCodexOpen = useAppSelector((state) => state.panels.codex);
  const [isSettingsOpen, setIsSettingsOpen] = React.useState(!settingsFirstSet);
  const [topupToken,setTopupToken]=React.useState<string>();

  React.useEffect(() => {
    const ver = localStorage.getItem(`server-${serverId}-version`);

    if (ver !== serverVersion) {
      localStorage.setItem(`server-${serverId}-version`, serverVersion);
      localStorage.setItem(`settings-tab-open-patch-notes`, '');
      setIsSettingsOpen(true);
    }
  }, [serverId, serverVersion]);

  function setMute(_mute: boolean) {
    dispatch(setSetting({ mute: _mute }));
    mute(_mute);
  }

  const onControlTouch = (event: React.TouchEvent) => {
    const button = (event.target as Element).closest('button');
    if (button && !button.disabled) { event.preventDefault(); event.stopPropagation(); button.click(); }
  };
  const logout = () => { logOff(!mobile); dispatch(switchState(SiteState.LANDING)); };
  const controls = mobile ? (
    <div className="game-hud mobile-side-controls" style={{position:'absolute',right:1,top:180,width:75,display:'flex',flexDirection:'column',gap:5,zIndex:30}} onPointerDown={event=>event.stopPropagation()} onTouchEnd={onControlTouch}>
      <JButton text="Codex" onClick={()=>dispatch(isCodexOpen?hideCodex():showCodex())}/>
      <JButton text="Settings" onClick={()=>setIsSettingsOpen(!isSettingsOpen)}/>
      <JButton text="Log Off" onClick={logout}/>
      <button type="button" className="game-sound-toggle" aria-label={isMuted?'เปิดเสียงเพลง':'ปิดเสียงเพลง'} onClick={()=>setMute(!isMuted)} style={{width:44,height:44,alignSelf:'center',padding:0,border:0,background:'transparent'}}><ShinobiSpeaker muted={isMuted}/></button>
      <button type="button" className="mobile-game-topup" aria-label="เติมเงิน" title="เติมเงิน" onClick={()=>{const token=getUserCenterToken();if(token)setTopupToken(token);else logout();}} style={{width:75,height:48,alignSelf:'center',padding:0,border:0,background:'transparent',cursor:'pointer'}}><img src={topupIcon} alt="" style={{display:'block',width:'100%',height:'100%',objectFit:'contain',pointerEvents:'none'}}/></button>
    </div>
  ) : (
    <div className="game-top-controls" style={{position:'absolute',right:1,top:3,display:'flex',gap:5}} onTouchEnd={onControlTouch}>
      <Ping/>
      <button type="button" className="game-sound-toggle" aria-label={isMuted?'เปิดเสียงเพลง':'ปิดเสียงเพลง'} onClick={()=>setMute(!isMuted)} style={{width:28,height:25,padding:0,border:0,background:'transparent'}}><CDNImage src={isMuted?'features/top-menu/sound-off.png':'features/top-menu/sound-on.png'} width={22} height={18}/></button>
      <JButton text="Codex" onClick={()=>dispatch(isCodexOpen?hideCodex():showCodex())}/>
      <JButton text="Settings" onClick={()=>setIsSettingsOpen(!isSettingsOpen)}/>
      <JButton text="Log Off" onClick={logout}/>
    </div>
  );

  return (
    <>
      <div className="game-hud game-top-hud" style={{ position: 'absolute', top: 1, left: 1, width: 'calc(100% - 7px)', height: 33 }}>
        <div style={{ position: 'relative' }}>
          <NineSlice url={TopMenuBG} slice={[8, 20]} style={{ width: '100%', height: 24, position: 'absolute', top: 0 }} />
          <CDNImage src={'features/top-menu/stone.png'} style={{ position: 'absolute', top: 2, left: 4 }} />
          <MultilineLabel
            size={{ width: 80, height: 15 }}
            position={{ x: 30, y: 6 }}
            text={stones ? stones.toString() : '0'}
            style={{ color: 'whitesmoke', textAlign: 'right' }}
          />
          <CDNImage src={'features/top-menu/coupon.png'} style={{ position: 'absolute', top: 2, left: 125 }} />
          <MultilineLabel
            size={{ width: 80, height: 15 }}
            position={{ x: 150, y: 6 }}
            text={currency.giftCertificates.toString()}
            style={{ color: 'whitesmoke', textAlign: 'right' }}
          />
          <CDNImage src={'features/top-menu/gold.png'} style={{ position: 'absolute', top: 2, left: 246 }} />
          <MultilineLabel
            size={{ width: 80, height: 15 }}
            position={{ x: 271, y: 6 }}
            text={(currency.gold ?? 0).toString()}
            title="Gold"
            style={{ color: 'whitesmoke', textAlign: 'right' }}
          />
        </div>
        {mobile ? <div style={{position:'absolute',right:8,top:5}}><Ping/></div> : controls}
        <Portrait />
        <Vip />
      </div>
      {mobile && controls}
      {topupToken&&<UserCenter jwt={topupToken} initialTab="topup" inGame onClose={()=>setTopupToken(undefined)}/>}
      {isSettingsOpen && <Settings onClose={() => setIsSettingsOpen(false)} />}
      <Codex />
    </>
  );
};
